document.addEventListener("DOMContentLoaded", function () {
  if (
    !window.theme ||
    !theme.settings ||
    !theme.settings.related_products_enabled
  ) {
    console.log("[UPSELL POPUP] ❌ Función desactivada desde settings");
    console.log(theme.settings);
    console.log("[UPSELL DEBUG] theme.settings:", theme.settings);
    return;
  }

  console.log("[UPSELL POPUP] ✅ Función activada");

  const THRESHOLD = parseInt(
    theme.settings.related_products_threshold || "150000",
    10
  );
  const COLLECTION_A =
    theme.settings.related_products_collection_a || "complementarios-a";
  const COLLECTION_B =
    theme.settings.related_products_collection_b || "complementarios-b";

  const contenedorPopup = document.querySelector(".pt-upsell-popup-wrapper");
  const modalPopup = document.querySelector("#modalAddToCartProduct");
  const modalProductElement = modalPopup.querySelector(".pt-modal-product");
  const productHandle = modalProductElement?.getAttribute(
    "data-product-handle"
  );

  if (!contenedorPopup || !modalPopup) {
    console.warn("[UPSELL POPUP] ⚠️ Contenedor no encontrado en el popup");
    return;
  }

  function obtenerSubtotalCarrito() {
    const totalElement = document.querySelector(
      ".pt-cart-total-price, .pt-modal-product .pt-price"
    );
    if (!totalElement) {
      console.warn("[UPSELL POPUP] ⚠️ No se encontró el elemento del subtotal");
      return 0;
    }

    const texto = totalElement.textContent || "";
    const valorNumerico = parseInt(texto.replace(/[^\d]/g, ""), 10);
    return isNaN(valorNumerico) ? 0 : valorNumerico;
  }

  function getRandomProducts(arr, count) {
    return arr.sort(() => Math.random() - 0.5).slice(0, count);
  }

  function renderCategoriasSugeridas() {
    const categorias = [1, 2, 3].map((i) => ({
      titulo: theme.settings[`upsell_category_${i}_title`] || "",
      imagen: theme.settings[`upsell_category_${i}_image`] || "",
      link: theme.settings[`upsell_category_${i}_link`] || "#",
    }));

    const htmlCategorias = categorias.map((cat) => `
      <div class="pt-categoria">
        <a href="${cat.link}" target="_blank" rel="noopener noreferrer">
          <img src="${cat.imagen}" alt="${cat.titulo}" style="max-width:100%; border-radius: 6px;" />
          <div class="pt-categoria-titulo" style="margin-top: 8px; font-weight: bold;">${cat.titulo}</div>
        </a>
      </div>
    `).join("");

    contenedorPopup.innerHTML = `
      <div class="pt-upsell-popup-title">${theme.settings.upsell_popup_heading_text || "Categorías recomendadas"}</div>
      <div class="pt-upsell-categorias-wrapper" style="display: flex; gap: 16px; justify-content: center; flex-wrap: wrap;">
        ${htmlCategorias}
      </div>
    `;

    contenedorPopup.style.display = "block";
  }

  function cargarProductos(coleccion) {
    console.log(`[UPSELL POPUP] 🔄 Cargando productos de: ${coleccion}`);

    const productoAgregado =
      modalPopup.querySelector(".pt-title")?.textContent?.trim() || "";
    const color =
      modalPopup.querySelector(".pt-add-info li:nth-child(1)")?.textContent?.trim() || "";
    const talla =
      modalPopup.querySelector(".pt-add-info li:nth-child(2)")?.textContent?.trim() || "";
    const cantidad =
      modalPopup.querySelector(".pt-qty span")?.textContent?.trim() || "1";
    const precio =
      modalPopup.querySelector(".pt-qty .cur-product-js")?.textContent?.trim() || "";

    fetch(`/collections/${coleccion}/products.json?limit=50`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.products || data.products.length === 0) {
          console.warn("[UPSELL POPUP] ⚠️ Colección vacía, usando aleatoria");
          return cargarProductos("all");
        }

        let productos = data.products;
        console.log("[UPSELL POPUP] 🧪 Productos recibidos:", productos.map(p => p.title));

        if (productos.length >= 50) {
          console.warn("[UPSELL POPUP] ⚠️ La colección tiene 50 o más productos. La aleatorización puede no cubrir toda la colección.");
        }

        if (theme.settings.upsell_randomize_products) {
          if (productos.length > 9) {
            productos = getRandomProducts(productos, 9);
            console.log("[UPSELL POPUP] 🔀 Randomización aplicada");
          } else {
            console.log("[UPSELL POPUP] 🟡 No se aplica random: menos de 9 productos");
          }
        } else {
          console.log("[UPSELL POPUP] 🔁 Randomización desactivada");
        }

        const html = productos
          .slice(0, 9)
          .map((p) => {
            const rawPrecio = p.variants?.[0]?.price || 0;
            const rawComparacion = p.variants?.[0]?.compare_at_price || 0;
            console.log(`[UPSELL PRICE DEBUG] ${p.title}: rawPrecio = ${rawPrecio}, rawComparacion = ${rawComparacion}`);

            const precio = parseFloat(rawPrecio);
            const precioRedondeado = precio;
            console.log("[UPSELL PRICE DEBUG] Formateando precio:", precio);
            const comparacion = parseFloat(rawComparacion);

            let precioHtml = "";
            if (theme.settings.upsell_show_prices) {
              console.log("[UPSELL PRICE DEBUG] Mostrar precios activado:", theme.settings.upsell_show_prices);
              const precioCOP = precioRedondeado.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              });
              const comparacionCOP = comparacion.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              });

              precioHtml =
                comparacion > precio
                  ? `<div class="pt-precio">
                        <span class="tachado">${comparacionCOP}</span>
                        <span class="oferta">${precioCOP}</span>
                     </div>`
                  : `<div class="pt-precio">${precioCOP}</div>`;
            }
            console.log("[UPSELL PRICE DEBUG] HTML generado para producto:", p.title, precioHtml);
            return `
              <div class="producto-item">
                <a href="/products/${p.handle}" title="${p.title}">
                  <img src="${p.images?.[0]?.src || ""}" style="max-width:100%" />
                  <div class="tituloproductopopup">${p.title}</div>
                  ${precioHtml}
                </a>
              </div>`;
          })
          .join("");

        contenedorPopup.innerHTML = `
    <p class="pt-upsell-resumen">✅ Agregaste: ${productoAgregado} - ${color} / ${talla} - ${cantidad} x ${precio}</p>
    ${
      theme.settings.upsell_popup_banner_url
        ? `<div class="pt-upsell-popup-banner">
              <a href="${theme.settings.upsell_popup_banner_link || "#"}" target="_blank">
                <img src="${theme.settings.upsell_popup_banner_url}" alt="Upsell banner" style="max-width:100%;margin-bottom:10px;" />
              </a>
          </div>`
        : ""
    }
    ${
      theme.settings.upsell_popup_heading_text &&
      theme.settings.upsell_popup_heading_text !== "#"
        ? `<div class="pt-upsell-popup-title">${theme.settings.upsell_popup_heading_text}</div>`
        : ""
    }
    <div class="pt-upsell-carousel-wrapper">
      <div class="pt-upsell-carousel-scroll">
        ${html}
      </div>
    </div>
  `;

        contenedorPopup.innerHTML += `
          <div class="pt-carousel-controls">
            <button class="pt-carousel-btn left" aria-label="Anterior">‹</button>
            <button class="pt-carousel-btn right" aria-label="Siguiente">›</button>
          </div>
        `;

        contenedorPopup.innerHTML += `
          <div class="pt-upsell-vermas-wrapper" style="text-align: center; margin-top: 10px;">
            <a href="/collections/${coleccion}" class="pt-upsell-vermas">
              Ver toda la colección
            </a>
          </div>
        `;

        contenedorPopup.style.display = "block";

        const scrollContainer = document.querySelector(".pt-upsell-carousel-scroll");

        const btnLeft = document.querySelector(".pt-carousel-btn.left");
        const btnRight = document.querySelector(".pt-carousel-btn.right");

        if (btnLeft && scrollContainer) {
          btnLeft.addEventListener("click", () => {
            scrollContainer.scrollLeft -= 240;
          });
        }

        if (btnRight && scrollContainer) {
          btnRight.addEventListener("click", () => {
            scrollContainer.scrollLeft += 240;
          });
        }

        scrollContainer.setAttribute("touch-action", "pan-x");

        let autoplayInterval;
        function startAutoplay() {
          autoplayInterval = setInterval(() => {
            if (scrollContainer) {
              scrollContainer.scrollLeft += 240;
            }
          }, 5000);
        }

        function stopAutoplay() {
          clearInterval(autoplayInterval);
        }

        if (scrollContainer) {
          scrollContainer.addEventListener("mouseenter", stopAutoplay);
          scrollContainer.addEventListener("touchstart", stopAutoplay);
          scrollContainer.addEventListener("mouseleave", startAutoplay);
          startAutoplay();
        }
      })
      .catch((err) => {
        console.error("[UPSELL POPUP] Error cargando productos:", err);
      });
  }

  // Detectar cuándo se abre el modal
  $("#modalAddToCartProduct").on("shown.bs.modal", function () {
    const subtotal = obtenerSubtotalCarrito();
    console.log(`[UPSELL POPUP] 💰 Subtotal detectado: ${subtotal}`);
    const umbral = parseInt(
      theme.settings.related_products_threshold || "150000",
      10
    );
    const coleccion =
      subtotal >= umbral
        ? theme.settings.related_products_collection_b
        : theme.settings.related_products_collection_a;
    if (theme.settings.upsell_show_categories_mode) {
      console.log("[UPSELL POPUP] 🧭 Modo categorías activado. Se omite carga de productos.");
      renderCategoriasSugeridas();
    } else {
      cargarProductos(coleccion);
    }
  });
});
